import React from "react";
import styled from "styled-components";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import { loginWithGoogleInWeb } from "common/assets/js/firebase";
import { tabColor, tabTextColor } from "common/constants/Colors";

const slidesData = [
  {
    key: "1",
    title: "タブで分けられます",
    text: "メモをタブごとにカテゴリー分けできます",
    text2: "スワイプで簡単にタブの切り替えができます",
  },
  {
    key: "2",
    title: "さっと書き始められます",
    text: "右下のボタンですぐに",
    text2: "選択中のタブにメモを追加できます",
  },
  {
    key: "3",
    title: "メモの削除は長押し",
    text: "長押しすると削除や",
    text2: "別なタブへの移動ができます",
  },
  {
    key: "4",
    title: "タブもすぐ増やせます",
    text: "右上の＋ボタンを押すとタブが増やせます",
    text2: "タブを長押しで削除や名前の変更ができます",
  },
  {
    key: "5",
    title: "文字数もわかります",
    text: "書いているメモの文字数が",
    text2: "リアルタイムに更新されます",
  }
];

const CustomPrevArrow = (props: any) => {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, display: "block" }}
      onClick={onClick}
    >
      ◁
    </div>
  );
};

const CustomNextArrow = (props: any) => {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, display: "block" }}
      onClick={onClick}
    >
      ▷
    </div>
  );
};

export default class Login extends React.Component<{}, { slideIndex: number }> {
  constructor(props) {
    super(props);
    this.state = {
      slideIndex: 0,
    };
  }

  render() {
    const { slideIndex } = this.state;
    const currentBgColor = tabColor[slideIndex];
    const currentTextColor = tabTextColor[slideIndex];

    const sliderSettings = {
      dots: false,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      prevArrow: <CustomPrevArrow />,
      nextArrow: <CustomNextArrow />,
      beforeChange: (current, next) => this.setState({ slideIndex: next })
    };

    return (
      <PageContainer>
        <FirstView>
          <div className="right">
            <h1>
              <img src="/img/firstview/title.png" alt="tabmemo" />
            </h1>
            <p className="subtitle">タブで分けられるシンプルなメモ帳</p>
            <p>iPhone・Android・PCでメモを共有できます</p>
          </div>
          <div className="left">
            <img className="sample" src="/img/firstview/body.png" alt="sample" />
          </div>
        </FirstView>

        <SlideSection style={{ backgroundColor: currentBgColor, color: currentTextColor }}>
          <div className="container">
            <div className="slides-wrapper">
              <Slider {...sliderSettings}>
                {slidesData.map((slide) => (
                  <div key={slide.key} className="slide-item">
                    <h3>{slide.title}</h3>
                    <img src={`/img/tutorial/${slide.key}.png`} alt={slide.title} />
                    <p>{slide.text}</p>
                    <p>{slide.text2}</p>
                  </div>
                ))}
              </Slider>
            </div>
          </div>
        </SlideSection>

        <BottomSection>
          <div className="action-area">
            <button className="btn" onClick={() => loginWithGoogleInWeb()}>
              Googleアカウントでログイン or 登録
            </button>
            <p className="subdescription">
              アプリ版は現在配信停止中です。
            </p>
          </div>
          <footer>
            <a href="/">トップ</a>
            <a
              href="https://docs.nabettu.com/terms/"
              target="_blank"
              rel="noopener noreferrer"
            >
              利用規約
            </a>
            <a
              href="https://docs.nabettu.com/privacy/"
              target="_blank"
              rel="noopener noreferrer"
            >
              プライバシーポリシー
            </a>
            <a
              href="https://docs.nabettu.com/contact/"
              target="_blank"
              rel="noopener noreferrer"
            >
              お問い合わせ
            </a>
            <a
              href="https://docs.nabettu.com/faq/"
              target="_blank"
              rel="noopener noreferrer"
            >
              よくある質問
            </a>
          </footer>
        </BottomSection>
      </PageContainer>
    );
  }
}

const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  width: 100%;
`;

const FirstView = styled.div`
  max-width: 800px;
  width: 100%;
  margin: 0 auto;
  padding: 64px 16px 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;

  @media (max-width: 768px) {
    flex-direction: column;
  }

  .right {
    width: 300px;
    margin: 0 auto;
    text-align: center;
    h1 {
      font-family: 'Work Sans', sans-serif;
      font-weight: 100;
      margin-bottom: 32px;
      font-size: 32px;
      width: 100%;
      img {
        display: block;
        width: 80%;
        margin: 0 auto;
      }
    }
    .subtitle {
      font-size: 18px;
      margin-bottom: 8px;
    }
    p {
      font-size: 14px;
      margin-bottom: 32px;
      font-weight: normal;
    }
  }
  .left {
    .sample {
      display: block;
      margin: 0 auto;
      width: 80%;
      max-width: 350px;
      object-fit: contain;
    }
  }
`;

const SlideSection = styled.div`
  transition: background-color 0.3s, color 0.3s;
  padding: 48px 16px;
  .container {
    max-width: 800px;
    margin: 0 auto;
  }
  .slides-wrapper {
    max-width: 320px;
    margin: 0 auto;
    text-align: center;
    h3 {
      margin-bottom: 32px;
      font-size: 24px;
    }
    p {
      line-height: 2em;
    }
    img {
      margin: 0 auto 16px;
      height: 320px;
      object-fit: contain;
    }
  }

  /* Custom slick styles to match original */
  .slick-arrow {
    z-index: 1;
    color: inherit;
    font-size: 32px;
    line-height: 1;
    width: auto;
    height: auto;
    display: flex !important;
    align-items: center;
    justify-content: center;
  }
  .slick-arrow:before {
    display: none;
  }
  .slick-arrow:hover, .slick-arrow:focus {
    color: inherit;
    opacity: 0.75;
  }
  .slick-prev {
    left: -16px;
  }
  .slick-next {
    right: -16px;
  }
`;

const BottomSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 64px 0 16px;
  position: relative;
  min-height: 300px;

  .action-area {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 64px;
  }

  .btn {
    margin-top: 64px;
    background-color: ${tabColor[0]};
    color: ${tabTextColor[0]};
    padding: 16px 32px;
    border-radius: 4px;
    font-size: 16px;
    cursor: pointer;
    border: none;
    /* font-weight: bold; */ /* Removed to strictly match original Login.tsx */
  }

  .subdescription {
    margin-top: 32px;
    color: #666;
    font-size: 13px;
  }

  footer {
    position: absolute;
    left: 0;
    bottom: 0;
    padding: 16px;
    box-sizing: border-box;
    width: 100%;
    display: flex;
    justify-content: center;
    a {
      color: ${tabColor[0]};
      margin: 0 8px;
      text-decoration: none;
    }
  }
`;
